/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './NewsletterPromo.scss';

import { Box, FlexCol, FlexRow, Heading } from 'sarsaparilla';

import { NewsletterSubscribeForm } from '../NewsletterSubscribeForm/NewsletterSubscribeForm';

export type NewsletterPromoProps = {
    hasLightBackground?: boolean;
    isFullWidth?: boolean;
};

export function NewsletterPromo({
    hasLightBackground = false,
    isFullWidth = false,
}: NewsletterPromoProps) {
    const backgroundClass = hasLightBackground ? 'background-light' : '';

    const inner = (
        <FlexRow className="rec-section-outer-wrap">
            <FlexCol md={8} xxl={6} className="nav-newsletter-content-col">
                <Heading
                    headingLevel={3}
                    appearance="h4"
                    className="nav-newsletter-title"
                >
                    Let&#39;s Stay in Touch
                </Heading>
                <p>
                    Get travel planning ideas, helpful tips, and stories from our visitors
                    delivered right to your inbox.
                </p>

                <NewsletterSubscribeForm hasLightBackground={hasLightBackground} />
            </FlexCol>
        </FlexRow>
    );

    return (
        <Box className={`nav-newsletter ${backgroundClass} px-3`}>
            <section aria-label="Newsletter signup">
                {isFullWidth ? (
                    <FlexRow justifyContent="center">
                        <FlexCol lg={12} xl={10} xxl={8}>
                            {inner}
                        </FlexCol>
                    </FlexRow>
                ) : (
                    inner
                )}
            </section>
        </Box>
    );
}
